import React, { useEffect, useMemo } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { RETAIL_USER_WALLETS } from "@common/constants/wallets/RetailUserWallets";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react-lite";

export default observer(function AccountStatementOnlineUserShopDropdown() {
	if (!THEME_SETTINGS.isDKMW) {
		return null;
	}
	const rootStore = useRootAppStore();
	const form = useFormContext();
	const watchShopId = useWatch({
		name: "shopId",
	});
	const watchBettingAccountType = useWatch({
		name: "bettingAccountTypeAbrv",
	});
	const isRetailWallet = RETAIL_USER_WALLETS.has(watchBettingAccountType);

	const mapToShops = useMemo(() => {
		return Array.from(rootStore.userAuthStore.onlineUserShops.values()).map(
			(shop) => ({
				name: shop.displayName,
				id: shop.shopId,
				value: shop.shopId,
			})
		);
	}, [rootStore.userAuthStore.onlineUserWallets]);

	useEffect(() => {
		if (!isRetailWallet) {
			const currentShopId = form.getValues("shopId");
			const shop =
				rootStore.userAuthStore.onlineUserShops.get(currentShopId);
			if (!shop) {
				return;
			}
			if (!shop.wallets.some((w) => w.abrv == watchBettingAccountType)) {
				form.setValue("bettingAccountTypeAbrv", shop.wallets[0].abrv);
			}
		}
	}, [watchShopId]);

	if (rootStore.userAuthStore.onlineUserShops.size <= 1) {
		return null;
	}
	if (isRetailWallet) {
		return null;
	}

	return (
		<FormSelectField
			className="form__group"
			label="COMMON.SELECT_SHOP"
			name="shopId"
			dropdownData={mapToShops}
		/>
	);
});
